import {Slug} from "@buildwithflux/constants";

export function isLocalSlug(slug: string): boolean {
    return slug.startsWith("local:");
}

export function buildLocalSlug(slug: Slug): Slug {
    return `local:${slug}` as Slug;
}
